import styled from "styled-components";

const StyledStart = styled.div`
    position: relative;
`

export default StyledStart;